import React, {useState, useRef, createElement} from "react";
import {crud} from "../../crudRequests";
import SignatureModal from "./SignatureModal";
import {PiSignatureBold} from "react-icons/pi";
import {saveAs} from "file-saver";
import {TbFileImport, TbFileExport, TbTrash} from "react-icons/tb";
import {useToast} from "@chakra-ui/react";
import {Tooltip} from "@chakra-ui/react";

function isValidReactElementType(element) {
  return typeof element === "string" || typeof element === "function";
}

export default function Signature({
    ogirin,
    label = "Signature",
    setSignature,
    signature,
    setShowModal,
    required = false,
}) {
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const importRef = useRef(null);

  function renderLabel(labelValue) {
    if (React.isValidElement(labelValue)) return labelValue;

    if (
      labelValue &&
      typeof labelValue === "object" &&
      isValidReactElementType(labelValue.element)
    ) {
      const {element, key, props = {}, children} = labelValue;
      return createElement(element, {key, ...props}, children);
    }

    if (labelValue && typeof labelValue === "object") {
      return renderLabel(labelValue.children);
    }

    return <span>{labelValue || "Signature"}</span>;
  }

  function getLabelText(labelValue) {
    if (typeof labelValue === "string") return labelValue || "Signature";
    if (React.isValidElement(labelValue)) {
      return typeof labelValue.props?.children === "string"
        ? labelValue.props.children
        : "Signature";
    }
    if (labelValue && typeof labelValue === "object") {
      return typeof labelValue.children === "string"
        ? labelValue.children
        : "Signature";
    }
    return "Signature";
  }


  function onImport(ele) {
    try {
      setLoading(true);
      let files = ele.target.files;
      let file = files[0];
      console.log(file);
      if (!file?.type.match(/image.*/i)) return;
      var reader = new FileReader();

      reader.addEventListener("load", (e) => {
        console.log(e.target.result.length, ogirin);
        setSignature(e.target.result, ogirin);   
      });
      reader.readAsDataURL(file);
    } catch (error) {
     
      console.log(error);

    }finally{
      setLoading(false);
    }
  }
  return (
    <div className="mt-[0.5rem] text-[#604652]  w-[300px] flex flex-col justify-center">
      <div className="flex justify-between items-center">
        {renderLabel(label)}
     
      <div className="flex items-center mt-1 space-x-[2px]">
        <Tooltip label="Create Signature">
          <div
            className={`relative group ${
               ""
            }`}
          >
            <span
              className={`text-gray-700/40 ${
               "hover:text-gray-700"
              } flex justify-center items-center rounded-lg p-[2px] text-[1.2rem] ${
                 "cursor-pointer"
              }`}
              onClick={() =>  setShowModal(ogirin)}
            >
              <PiSignatureBold />
            </span>
          
          </div>
          </Tooltip>
          <Tooltip label="Import Signature">
          <div
            className={`relative group flex justify-center items-center ${
              "cursor-pointer"
            }`}
            htmlFor="import"
            onClick={(e) => {
              
              importRef.current.click();
            }}
          >
            <input
            onClick={(e) => {     
              e.target.value = "";
            }}
              onChange={(e) => {
                if (!loading ) onImport(e);
              }}
              ref={importRef}
              className="absolute w-0 h-0 opacity-0 z-0 cursor-pointer"
              type="file"
              name="import"
              accept=".jpg, .jpeg, .png"
            
            />
            <span
              className={`text-gray-700/40 z-0 ${
                "hover:text-gray-700"
              } flex justify-center items-center rounded-lg p-[2px] text-[1.2rem] ${
                "cursor-pointer"
              }`}
            >
              <TbFileImport />
            </span>
           
          </div>
          </Tooltip>
          {signature && (
            <Tooltip label="Export Signature">
            <div
              className={`relative group`}
            >
              <span
                className={`text-gray-700/40 ${
                  "hover:text-gray-700"
                } flex justify-center items-center rounded-lg p-[2px] text-[1.2rem] ${
                   "cursor-pointer"
                }`}
                onClick={() => {
            
                  try {
                    let base64Data = signature.split(",")[1];
                    var byteCharacters = atob(base64Data);

                    // Crea un array buffer y un Blob a partir del array de bytes
                    var arrayBuffer = new ArrayBuffer(byteCharacters.length);
                    var uint8Array = new Uint8Array(arrayBuffer);
                    for (var i = 0; i < byteCharacters.length; i++) {
                      uint8Array[i] = byteCharacters.charCodeAt(i);
                    }

                    var blob = new Blob([arrayBuffer], {type: "image/png"});

                    saveAs(blob, `${getLabelText(label)}.png`);
                  } catch (e) {
                    toast({
                      title: `Invalid signature!`,
                      status: "error",
                      duration: 3000,
                      isClosable: true,
                    });
                  }
                }}
              >
                <TbFileExport />
              </span>
             
            </div>
            </Tooltip>
          )}
          {signature && (
            <Tooltip label="Clear Signature">
            <div
              className={`relative group`}
            >
              <span
                className={`text-gray-700/40 ${
                  "hover:text-gray-700"
                } flex justify-center items-center rounded-lg p-[2px] text-[1.2rem] ${
                   "cursor-pointer"
                }`}
                onClick={() => {
                  setSignature('', ogirin);
                 
                }}
              >
                <TbTrash />
              </span>
             
            </div>
            </Tooltip>
          )}
      </div>
    </div>
    <div
              className={`rounded-md flex justify-center bg-white items-center h-[100px] w-[300px]  overflow-hidden ${
                "border-gray-500"
              } p-2 h-14`}
            >
              {signature && (
                <img
                  src={signature}
                  alt="signature"
                  className={`h-full object-contain`}
                />
              )}
            </div>
    </div>
  )


}
